import { render } from "./Rhymesaurus.vue?vue&type=template&id=01ac5755&scoped=true"
import script from "./Rhymesaurus.vue?vue&type=script&lang=js"
export * from "./Rhymesaurus.vue?vue&type=script&lang=js"

import "./Rhymesaurus.vue?vue&type=style&index=0&id=01ac5755&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cell8\\Desktop\\portfolio\\rhymeasaurus\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ac5755"]])

export default __exports__